const initializeRydeTrustStrips = (scope = document) => {
  const strips = [
    ...(scope.matches?.('[data-trust-strip]') ? [scope] : []),
    ...scope.querySelectorAll('[data-trust-strip]'),
  ];

  for (const strip of strips) {
    if (strip.dataset.trustInitialized === 'true') continue;
    strip.dataset.trustInitialized = 'true';

    const button = strip.querySelector('[data-trust-toggle]');
    button?.addEventListener('click', () => {
      const paused = strip.classList.toggle('is-paused');
      button.setAttribute('aria-pressed', String(paused));
      button.setAttribute('aria-label', paused ? 'Play benefits ticker' : 'Pause benefits ticker');
    });
  }
};

document.addEventListener('DOMContentLoaded', () => initializeRydeTrustStrips());
document.addEventListener('shopify:section:load', (event) => initializeRydeTrustStrips(event.target));
